'use strict';
var EmailPreferencesController = /** @class */ (function () {
    /*@ngInject*/
    function EmailPreferencesController($log, $q, EmailPreferenceService, $mdToast, $scope, seoMetaService) {
        // create the list of brand
        this.emailPreferences = [];
        this.notifications = [];
        // set the default amount of items being displayed
        this.limit = 10;
        var self = this;
        this.$log = $log;
        this.emps = EmailPreferenceService;
        this.$q = $q;
        this.$mdToast = $mdToast;
        this.$scope = $scope;
        this.seoMetaService = seoMetaService;
        this.seoMetaService.updateSeoMetaData(this, 'EmailPreferencesController');
        var userEmailPrefPromise = this.emps.getEmailPreferences();
        var allEmailPrefPromise = this.emps.getAllEmailPreferences();
        this.getUserEmailNotificationPreferences(userEmailPrefPromise, allEmailPrefPromise);
    }
    EmailPreferencesController.prototype.getPreference = function (optIn, item) {
        var emailPref = item.split(' - ');
        return {
            optin: optIn,
            type: emailPref[0],
            desc: emailPref[1]
        };
    };
    EmailPreferencesController.prototype.updatePreference = function (preference) {
        var self = this;
        if (preference.optin) {
            //Call POST
            self.emps.addEmailPreference(preference)
                .then(function (response) {
                self.showToast(response, preference);
            });
        }
        else {
            //Call DELETE
            self.emps.deleteEmailPreference(preference)
                .then(function (response) {
                self.showToast(response, preference);
            });
        }
    };
    EmailPreferencesController.prototype.savePreferences = function (preferenceType) {
        var self = this;
        if (preferenceType) {
            self.updatePreference(preferenceType);
        }
    };
    EmailPreferencesController.prototype.getUserEmailNotificationPreferences = function (userEmailPrefPromise, allEmailPrefPromise) {
        var self = this;
        this.$q.all([userEmailPrefPromise, allEmailPrefPromise]).then(function (results) {
            if (results) {
                if (results[1]) {
                    var allPreferences = results[1].data.response;
                    var userPreferences = results[0].data.response;
                    var index = allPreferences.indexOf('BackOrderEmailNotifications');
                    if (index > -1) {
                        allPreferences.splice(index, 1);
                    }
                    if (allPreferences) {
                        for (var i = 0, len = allPreferences.length; i < len; i++) {
                            var item = allPreferences[i];
                            if (item === 'BatchOrderEmails') {
                                //Notification
                                if (userPreferences.indexOf(item) > -1) {
                                    self.notifications.push(self.getPreference(true, item));
                                }
                                else {
                                    self.notifications.push(self.getPreference(false, item));
                                }
                            }
                            else {
                                //Email Preferences
                                if (userPreferences.indexOf(item) > -1) {
                                    self.emailPreferences.push(self.getPreference(true, item));
                                }
                                else {
                                    self.emailPreferences.push(self.getPreference(false, item));
                                }
                            }
                        }
                    }
                }
            }
        }, function (errors) {
        });
    };
    EmailPreferencesController.prototype.showSimpleToast = function (message, addMsg) {
        var msg = (addMsg != null) ? addMsg : '';
        this.$mdToast.show(this.$mdToast.simple({
            position: 'top right',
            hideDelay: 5000,
            parent: document.getElementById('toast'),
            template: require('./email-toast-template.html')
        }));
    };
    EmailPreferencesController.prototype.showToast = function (response, preference) {
        var self = this;
        if (response && response.status == '200') {
            self.showSimpleToast('Preferences Saved.', 'Your email settings have been saved.');
        }
        else {
            preference.optin = preference.optin == true ? false : true;
        }
    };
    return EmailPreferencesController;
}());
export default EmailPreferencesController;
//# sourceMappingURL=email-preferences.controller.js.map